(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ----------------------------------------
     StickyHeader — preserved from your build
     ---------------------------------------- */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ----------------------------------------
   Animated Mega Menu — handles open/close
   ---------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('header-menu').forEach(menuEl => {
    const details = menuEl.querySelector('details');
    const summary = menuEl.querySelector('summary');
    const content = summary.nextElementSibling;
    const header = document.querySelector('.header-wrapper');
    let isAnimating = false;

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (isAnimating) return;

      if (details.hasAttribute('open')) {
        // CLOSE: animate out, then remove [open]
        isAnimating = true;
        content.style.animation = 'megaMenuOut 0.3s cubic-bezier(0.25, 0.1, 0.25, 1) forwards';

        // Reset child items immediately
        content.querySelectorAll('.mega-menu__list > li').forEach(li => {
          li.style.opacity = '0';
          li.style.transform = 'translateY(8px)';
          li.style.animation = 'none';
        });

        setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          content.style.animation = '';
          content.querySelectorAll('.mega-menu__list > li').forEach(li => {
            li.style.opacity = '';
            li.style.transform = '';
            li.style.animation = '';
          });
          isAnimating = false;
          if (header) header.preventHide = false;
        }, 300);

      } else {
        // OPEN: reset animation, then add [open]
        content.style.animation = 'none';
        content.querySelectorAll('.mega-menu__list > li').forEach(li => {
          li.style.animation = 'none';
        });

        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');

        if (header) {
          header.preventHide = true;
          if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
            document.documentElement.style.setProperty(
              '--header-bottom-position-desktop',
              `${Math.floor(header.getBoundingClientRect().bottom)}px`
            );
          }
        }

        // Force reflow to reset animations
        void content.offsetHeight;

        // Re-enable animations
        content.style.animation = '';
        content.querySelectorAll('.mega-menu__list > li').forEach(li => {
          li.style.animation = '';
        });
      }
    });

    // Close on focus out
    details.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!menuEl.contains(document.activeElement) && details.hasAttribute('open') && !isAnimating) {
          summary.click();
        }
      });
    });
  });
});

/* ----------------------------------------
   Mega Menu Image Preview — hover to swap
   Preloads all images on menu open
   ---------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu__content').forEach(menuContent => {
    const previewImage = menuContent.querySelector('[data-mega-preview-image]');
    const previewCaption = menuContent.querySelector('[data-mega-preview-caption]');

    if (!previewImage || !previewCaption) return;

    const previewLinks = menuContent.querySelectorAll('.mega-menu__link[data-preview-image]');
    let imagesPreloaded = false;

    // Preload all collection images into browser cache
    function preloadImages() {
      if (imagesPreloaded) return;
      previewLinks.forEach(link => {
        const src = link.getAttribute('data-preview-image');
        if (src) {
          const img = new Image();
          img.src = src;
        }
      });
      imagesPreloaded = true;
    }

    // Trigger preload when the mega menu opens
    const details = menuContent.closest('details');
    if (details) {
      const observer = new MutationObserver(() => {
        if (details.hasAttribute('open')) {
          preloadImages();
        }
      });
      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
    }

    previewLinks.forEach(link => {
      link.addEventListener('mouseenter', () => {
        const imageSrc = link.getAttribute('data-preview-image');
        const caption = link.getAttribute('data-preview-caption') || '';

        if (imageSrc) {
          previewImage.innerHTML = `<img src="${imageSrc}" alt="${caption}">`;
        }

        previewCaption.textContent = caption;
      });
    });
  });
});

/* ----------------------------------------
   Editorial Mega Menu — hover blurb + image
   ---------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu__content--editorial').forEach(menu => {
    const blurbEl = menu.querySelector('[data-editorial-blurb]');
    const imageEl = menu.querySelector('[data-editorial-image]');
    const imageCaptionEl = menu.querySelector('[data-editorial-image-caption]');
    const links = menu.querySelectorAll('.mega-menu__link--editorial');

    if (!blurbEl || !imageEl) return;

    const details = menu.closest('details');
    let preloaded = false;
    if (details) {
      new MutationObserver(() => {
        if (details.hasAttribute('open') && !preloaded) {
          links.forEach(link => {
            const src = link.getAttribute('data-preview-image');
            if (src) { const img = new Image(); img.src = src; }
          });
          preloaded = true;
        } else if (!details.hasAttribute('open')) {
          blurbEl.classList.remove('is-visible');
          imageEl.classList.remove('is-visible');
          if (imageCaptionEl) imageCaptionEl.classList.remove('is-visible');
        }
      }).observe(details, { attributes: true, attributeFilter: ['open'] });
    }

    let hoverTimer;
    links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          const img = link.getAttribute('data-preview-image');
          const caption = link.getAttribute('data-preview-caption') || '';
          const imageCaption = link.getAttribute('data-preview-image-caption') || '';
          if (caption) blurbEl.textContent = caption;
          if (img) imageEl.innerHTML = `<img src="${img}" alt="${caption}">`;
          if (imageCaptionEl) imageCaptionEl.innerHTML = imageCaption;
          blurbEl.classList.add('is-visible');
          imageEl.classList.add('is-visible');
          if (imageCaptionEl) imageCaptionEl.classList.add('is-visible');
        }, 50);
      });
    });
  });
});

  /* ----------------------------------------
     Inline Search — expand/collapse
     ---------------------------------------- */
  class InlineSearch {
    constructor() {
      this.container = document.querySelector('[data-inline-search]');
      if (!this.container) return;

      this.trigger = this.container.querySelector('[data-search-trigger]');
      this.form = this.container.querySelector('[data-search-form]');
      this.input = this.container.querySelector('[data-search-input]');
      this.closeBtn = this.container.querySelector('[data-search-close]');

      this.isOpen = false;

      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });

      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.close();
        }
        if (e.key === 'Enter') {
          if (this.input.value.trim() === '') {
            e.preventDefault();
          }
        }
      });

      // Close on click outside
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.container.contains(e.target)) {
          this.close();
        }
      });
    }

    open() {
      this.container.classList.add('is-open');
      this.isOpen = true;
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.input.focus();
        }, 100);
      });
    }

    close() {
      this.container.classList.remove('is-open');
      this.isOpen = false;
      this.input.value = '';
      this.trigger.focus();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new InlineSearch();
  });

 /* Hoist data-header-theme from inner section elements to .shopify-section wrappers */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-header-theme]').forEach(el => {
    const wrapper = el.closest('.shopify-section');
    if (wrapper && !wrapper.hasAttribute('data-header-theme')) {
      wrapper.setAttribute('data-header-theme', el.getAttribute('data-header-theme'));
    }
  });
});
/* ----------------------------------------
   Dynamic Header Color — reads data-header-theme
   from section wrappers as they scroll past
   ---------------------------------------- */
class HeaderColorSwitcher {
  constructor() {
    this.headerWrapper = document.querySelector('.header-wrapper');
    if (!this.headerWrapper) return;

    this.currentTheme = 'light';
    this.setupObserver();
  }

  setupObserver() {
    const sections = document.querySelectorAll('main .shopify-section[data-header-theme]');
    if (sections.length === 0) return;

    const headerHeight = this.headerWrapper.offsetHeight;

    const observerOptions = {
      root: null,
      rootMargin: `0px 0px -${window.innerHeight - headerHeight - 2}px 0px`,
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      let topSection = null;
      let topY = Infinity;

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const rect = entry.boundingClientRect;
          if (rect.top < topY) {
            topY = rect.top;
            topSection = entry.target;
          }
        }
      });

      if (topSection) {
        const newTheme = topSection.getAttribute('data-header-theme') || 'light';
        if (newTheme !== this.currentTheme) {
          this.currentTheme = newTheme;
          this.headerWrapper.setAttribute('data-header-theme', newTheme);
        }
      }
    }, observerOptions);

    sections.forEach(section => {
      this.observer.observe(section);
    });

    // Also check on scroll for precise detection
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.checkSectionAtHeader();
          ticking = false;
        });
        ticking = true;
      }
    });

    this.checkSectionAtHeader();
  }

  checkSectionAtHeader() {
    const headerHeight = this.headerWrapper.offsetHeight;
    const checkY = headerHeight / 2;

    const oldPointerEvents = this.headerWrapper.style.pointerEvents;
    this.headerWrapper.style.pointerEvents = 'none';

    const elementBehind = document.elementFromPoint(window.innerWidth / 2, checkY);

    this.headerWrapper.style.pointerEvents = oldPointerEvents;

    if (elementBehind) {
      // Walk up to find the nearest .shopify-section with data-header-theme
      let current = elementBehind;
      while (current && current !== document.body) {
        if (current.classList.contains('shopify-section') && current.hasAttribute('data-header-theme')) {
          const newTheme = current.getAttribute('data-header-theme');
          if (newTheme !== this.currentTheme) {
            this.currentTheme = newTheme;
            this.headerWrapper.setAttribute('data-header-theme', newTheme);
          }
          return;
        }
        current = current.parentElement;
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    new HeaderColorSwitcher();
  }, 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-resources"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.home-resources');
    if (!sections.length) return;

    sections.forEach((section) => {
      const stage = section.querySelector('[data-resources-stage]');
      const imagesWrap = section.querySelector('[data-resources-images]');
      const images = section.querySelectorAll('[data-resources-image]');
      const descriptions = section.querySelectorAll('[data-resources-description]');
      const links = section.querySelectorAll('[data-resources-link]');
      if (!stage || !imagesWrap || !links.length) return;

      let hideTimer = null;

      const showForIndex = (index) => {
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        images.forEach((img) => {
          if (img.dataset.imageIndex === String(index)) {
            img.classList.add('is-active');
          } else {
            img.classList.remove('is-active');
          }
        });
        descriptions.forEach((desc) => {
          if (desc.dataset.descriptionIndex === String(index)) {
            desc.classList.add('is-active');
          } else {
            desc.classList.remove('is-active');
          }
        });
      };

      const hideAll = () => {
        images.forEach((img) => img.classList.remove('is-active'));
        descriptions.forEach((desc) => desc.classList.remove('is-active'));
      };

      links.forEach((link) => {
        link.addEventListener('mouseenter', () => {
          showForIndex(link.dataset.linkIndex);
        });

        link.addEventListener('focus', () => {
          showForIndex(link.dataset.linkIndex);
        });

        // Touch tap: first tap shows image + marks active, second tap navigates
        link.addEventListener('touchstart', (e) => {
          const alreadyActive = link.classList.contains('is-active');
          if (!alreadyActive) {
            e.preventDefault();
            links.forEach((l) => l.classList.remove('is-active'));
            link.classList.add('is-active');
            showForIndex(link.dataset.linkIndex);
          }
          // if already active, let the native tap navigate
        }, { passive: false });
      });

      // Hide when the mouse leaves the whole stage
      stage.addEventListener('mouseleave', () => {
        hideTimer = setTimeout(hideAll, 80);
      });

      // Tap outside to dismiss on touch devices
      document.addEventListener('touchstart', (e) => {
        if (!stage.contains(e.target)) {
          links.forEach((l) => l.classList.remove('is-active'));
          hideAll();
        }
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moodboard"] && !Shopify.designMode) return;
  try {
    
  
  jQuery(document).ready(function() {
    jQuery(".resizable").draggable({
      containment: ".moodboard"
    });
  });


  } catch(e) { console.error(e); }
})();
})();
